import { memo } from 'react';

import { useJoinGame } from '@/shared/lib/hooks/useJoinGame';
import { useTelegramBackButton } from '@/shared/lib/telegram/useTelegramBackButton';

import { MinesBetPanel, MinesGrid } from './ui';

export const MinesPage = memo(() => {
  useTelegramBackButton();
  useJoinGame('mines');

  return (
    <div className="game-page">
      <div className="game-page__canvas-wrap">
        <MinesGrid />
      </div>

      <div className="game-page__controls">
        <MinesBetPanel />
      </div>
    </div>
  );
});

export default MinesPage;
